module.exports = __webpack_public_path__ + "static/img/1000000501_blue.ca8bd680.jpg";